module.exports = __webpack_public_path__ + "img/logo_dk.ce01c9c8.png";